import { makeAutoObservable } from 'mobx'

export class ProfileFillNeedModalStore {
  isOpen: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setIsOpen(v: boolean) {
    this.isOpen = v
  }
}
